export const LoginMessages = {
  CHECK_IS_ADMIN_SUCCESS: 'Login Success',
  CHECK_IS_ADMIN_ERROR: 'Access Denied',

  SET_IS_ADMIN_SUCCESS: 'Admin confirmed!'
};

export const fileWidth = '_800x800';

export const isMobile = window.innerWidth <= 768;

export const Collections = { GALLERY: 'gallery', ORDERS: 'orders' };
